module.exports = __webpack_public_path__ + "img/code.fd4bee85.png";